import { useCallback, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { shouldQueueStreaksModal } from '../actions/streaks';

const useQueueStreaksModal = (): Function => {
  const dispatch = useDispatch();
  const queueStreaksModal = useCallback(
    (preventStreaksModalDisplay: boolean): void => {
      dispatch(shouldQueueStreaksModal(preventStreaksModalDisplay));
    },
    [dispatch],
  );

  useEffect(() => {
    queueStreaksModal(true);
    return (): void => {
      queueStreaksModal(false);
    };
  }, [queueStreaksModal]);

  return queueStreaksModal;
};

export default useQueueStreaksModal;
